import React, { useState, useCallback } from 'react'
import useLocaleText from 'components/useLocaleText'
import { ModalTitle, ModalSubtitle, StyledInput, ErrorMessage } from '../styles'

// Email validation regex
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

interface FeedStepProps {
  inputValue: string
  setInputValue: (value: string) => void
  onValidationChange: (isValid: boolean) => void
}

export const FeedStep: React.FC<FeedStepProps> = ({ inputValue, setInputValue, onValidationChange }) => {
  const t_connect_email = useLocaleText('connect_email', true)
  const feed_popup_desc = useLocaleText('feed_popup_desc', true)

  const [showError, setShowError] = useState(false)
  const [touched, setTouched] = useState(false)

  const validateEmail = useCallback(
    (value: string) => {
      const isValid = value.trim() !== '' && EMAIL_REGEX.test(value.trim())
      onValidationChange(isValid)

      if (touched) {
        setShowError(value.trim() !== '' && !EMAIL_REGEX.test(value.trim()))
      }
    },
    [onValidationChange, touched]
  )

  const handleBlur = useCallback(() => {
    setTouched(true)
    const isValid = EMAIL_REGEX.test(inputValue.trim())
    setShowError(inputValue.trim() !== '' && !isValid)
    onValidationChange(inputValue.trim() !== '' && isValid)
  }, [inputValue, onValidationChange])

  const handleChange = useCallback(
    (e: any) => {
      const value = e.target.value
      setInputValue(value)
      // Only validate on change if already touched
      if (touched) {
        validateEmail(value)
      } else {
        // Still update parent about validity for button state
        onValidationChange(value.trim() !== '' && EMAIL_REGEX.test(value.trim()))
      }
    },
    [setInputValue, touched, validateEmail, onValidationChange]
  )

  return (
    <>
      <ModalTitle>{t_connect_email}</ModalTitle>
      <ModalSubtitle>{feed_popup_desc}</ModalSubtitle>
      <StyledInput
        placeholder="demo@demo.com"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        hasError={showError}
      />
      {showError && <ErrorMessage>Please enter a valid email address</ErrorMessage>}
    </>
  )
}
